import React from "react";
import { TextInputField } from "@jsluna/form";

export default class EmailInput extends React.Component {
  render() {
    return (
      <div>
        <TextInputField
          name={this.props.name}
          type="email"
          pattern="/^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/"
          maxLength={128}
          placeholder={this.props.placeholder}
          info={this.props.info}
          label={this.props.label}
          onChange={this.props.handleChange}
          onBlur={this.props.handleBlur}
          value={this.props.username}
          error={this.props.formErrors[this.props.name]}
          onCopy={this.props.oncopy}
          onPaste={this.props.onpaste}
          validationFirst
          required
        />
      </div>
    );
  }
}

EmailInput.defaultProps = {
  placeholder: "Enter email address",
  info: "Enter email address",
  label: "Enter email address",
  name: "username",
};
